import { css } from '@emotion/react';
import { tokens } from '../../tokens';
/** Used _internally_ only, to help with mapping values for dark theme.
 * @see darkThemeStyle for external usage */
export const INTERNAL_DARK_MODE_MAPPING = {
    '--wf-bg--active': tokens.colors.white10,
    '--wf-bg--contrast': tokens.colors.navyLight,
    '--wf-bg--contrast-inverse': tokens.colors.white,
    '--wf-bg--focus': tokens.colors.white6,
    '--wf-bg--hover': tokens.colors.white6,
    '--wf-bg--hover-strong': tokens.colors.white20,
    '--wf-bg--hover-strong-inverse': tokens.colors.grey10,
    '--wf-bg--main': tokens.colors.navy,
    '--wf-bg--secondary': tokens.colors.navyMedium,
    '--wf-bg--tertiary': tokens.colors.navyDark,
    '--wf-bg--transparent': tokens.colors.white20,
    '--wf-bg--transparent-inverse': tokens.colors.grey10,
    '--wf-blue--darker': tokens.colors.blueDark,
    '--wf-blue--lighter': tokens.colors.blueLight,
    '--wf-blue--main': tokens.colors.blue,
    '--wf-blue--text': tokens.colors.blue,
    '--wf-blue--text-on-color': tokens.colors.navy,
    '--wf-blue--transparent': tokens.colors.blueDark15,
    '--wf-border-color--focus-outline': tokens.colors.blueDark,
    '--wf-border-color--interactive': tokens.colors.white60,
    '--wf-border-color--main': tokens.colors.white15,
    '--wf-border-color--strong': tokens.colors.white30,
    '--wf-box-shadow--medium': '0px 3px 10px -1px rgba(0, 8, 32, 0.8)',
    '--wf-box-shadow--thick': '0px 5px 15px -1px rgba(0, 8, 32, 0.8)',
    '--wf-box-shadow--thin': '0px 0px 3px 0px rgba(0, 8, 32, 0.8)',
    '--wf-box-shadow--xthick': '0px 8px 20px -4px rgba(0, 8, 32, 0.8)',
    '--wf-brand--darker': tokens.colors.greenDark,
    '--wf-brand--lighter': tokens.colors.greenLight,
    '--wf-brand--main': tokens.colors.green,
    '--wf-brand--text': tokens.colors.white,
    '--wf-brand--text-on-color': tokens.colors.navy,
    '--wf-brand--text-subtle': tokens.colors.white60,
    '--wf-error--darker': tokens.colors.redDark,
    '--wf-error--lighter': tokens.colors.redLight,
    '--wf-error--main': tokens.colors.red,
    '--wf-error--text': tokens.colors.redLight,
    '--wf-error--text-on-color': tokens.colors.white,
    '--wf-error--transparent': tokens.colors.red20,
    '--wf-green--darker': tokens.colors.greenDark,
    '--wf-green--lighter': tokens.colors.greenLight,
    '--wf-green--main': tokens.colors.green,
    '--wf-green--text': tokens.colors.green,
    '--wf-green--text-on-color': tokens.colors.navy,
    '--wf-green--transparent': tokens.colors.greenLight20,
    '--wf-grey--darker': tokens.colors.greyMedium,
    '--wf-grey--lighter': tokens.colors.greyLight,
    '--wf-grey--main': tokens.colors.grey,
    '--wf-grey--subtler': tokens.colors.greySubtle,
    '--wf-grey--text': tokens.colors.greySubtle,
    '--wf-grey--text-on-color': tokens.colors.navy,
    '--wf-grey--transparent': tokens.colors.white10,
    '--wf-info--darker': tokens.colors.blueDark,
    '--wf-info--lighter': tokens.colors.blueLight,
    '--wf-info--main': tokens.colors.blue,
    '--wf-info--text': tokens.colors.blue,
    '--wf-info--text-on-color': tokens.colors.navy,
    '--wf-info--transparent': tokens.colors.blue20,
    '--wf-navy--darker': tokens.colors.navyDark,
    '--wf-navy--lighter': tokens.colors.navyMedium,
    '--wf-navy--main': tokens.colors.navy,
    '--wf-navy--subtler': tokens.colors.navyLight,
    '--wf-navy--text': tokens.colors.navyLight,
    '--wf-navy--text-on-color': tokens.colors.white,
    '--wf-navy--transparent': tokens.colors.navy10,
    '--wf-orange--darker': tokens.colors.orangeDark,
    '--wf-orange--lighter': tokens.colors.orangeLight,
    '--wf-orange--main': tokens.colors.orange,
    '--wf-orange--text': tokens.colors.orange,
    '--wf-orange--text-on-color': tokens.colors.navy,
    '--wf-orange--transparent': tokens.colors.orange16,
    '--wf-pink--darker': tokens.colors.pinkDark,
    '--wf-pink--lighter': tokens.colors.pinkLight,
    '--wf-pink--main': tokens.colors.pink,
    '--wf-pink--text': tokens.colors.pink,
    '--wf-pink--text-on-color': tokens.colors.navy,
    '--wf-pink--transparent': tokens.colors.pinkDark20,
    '--wf-purple--darker': tokens.colors.purpleDark,
    '--wf-purple--lighter': tokens.colors.purpleLight,
    '--wf-purple--main': tokens.colors.purple,
    '--wf-purple--text': tokens.colors.purpleLight,
    '--wf-purple--text-on-color': tokens.colors.white,
    '--wf-purple--transparent': tokens.colors.purple18,
    '--wf-red--darker': tokens.colors.redDark,
    '--wf-red--lighter': tokens.colors.redLight,
    '--wf-red--main': tokens.colors.red,
    '--wf-red--text': tokens.colors.redLight,
    '--wf-red--text-on-color': tokens.colors.white,
    '--wf-red--transparent': tokens.colors.redDark16,
    '--wf-success--darker': tokens.colors.greenDark,
    '--wf-success--lighter': tokens.colors.greenLight,
    '--wf-success--main': tokens.colors.green,
    '--wf-success--text': tokens.colors.green,
    '--wf-success--text-on-color': tokens.colors.navy,
    '--wf-success--transparent': tokens.colors.green20,
    '--wf-text--inverse': tokens.colors.navy,
    '--wf-text--inverse-subtle': tokens.colors.navySubtleTextOnLight,
    '--wf-text--link': tokens.colors.blue,
    '--wf-text--main': tokens.colors.greyLight,
    '--wf-text--secondary': tokens.colors.greyMedium,
    '--wf-text--subtle': tokens.colors.navySubtleTextOnDark,
    '--wf-transparent-grey--darker': tokens.colors.white30,
    '--wf-transparent-grey--lighter': tokens.colors.white15,
    '--wf-transparent-grey--main': tokens.colors.white20,
    '--wf-transparent-grey--subtler': tokens.colors.white10,
    '--wf-transparent-grey--text': tokens.colors.greyMedium,
    '--wf-transparent-grey--text-on-color': tokens.colors.white,
    '--wf-upgrade--darker': tokens.colors.purpleDark,
    '--wf-upgrade--lighter': tokens.colors.purpleLight,
    '--wf-upgrade--main': tokens.colors.purple,
    '--wf-upgrade--text': tokens.colors.purpleLight,
    '--wf-upgrade--text-on-color': tokens.colors.white,
    '--wf-upgrade--transparent': tokens.colors.purple20,
    '--wf-warning--darker': tokens.colors.orangeDark,
    '--wf-warning--lighter': tokens.colors.orangeLight,
    '--wf-warning--main': tokens.colors.orange,
    '--wf-warning--text': tokens.colors.orange,
    '--wf-warning--text-on-color': tokens.colors.navy,
    '--wf-warning--transparent': tokens.colors.orange20,
    '--wf-white--main': tokens.colors.white,
    '--wf-white--text': tokens.colors.white,
    '--wf-white--text-on-color': tokens.colors.navy,
    '--wf-white--transparent': tokens.colors.white20,
    '--wf-yellow--darker': tokens.colors.yellowDark,
    '--wf-yellow--lighter': tokens.colors.yellowLight,
    '--wf-yellow--main': tokens.colors.yellow,
    '--wf-yellow--text': tokens.colors.yellow,
    '--wf-yellow--text-on-color': tokens.colors.navy,
    '--wf-yellow--transparent': tokens.colors.yellow18,
};
export const darkThemeStyle = css([
    { colorScheme: 'dark' },
    INTERNAL_DARK_MODE_MAPPING,
]);
